<template>
  <div class="w-full col-span-full">
    <info-bulle
      v-if="label"
      :name="'name'"
      :is-libelle-input="true"
    >
      <template #libelleBefore>
        <div
          class="text-sm text-gray-600 truncate mb-2 flex items-center gap-x-1"
          @mouseover="tooltipLabel = true"
          @mouseleave="tooltipLabel = false"
        >
          {{ label }}
        </div>
      </template>
      <template #tooltipLibelleBefore>
        <!-- Display libelle when hover -->
        <transition
          enter-active-class="duration-300 delay-1000"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="duration-300"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="tooltipLabel && label"
            class="absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-8 z-30 p-3 text-sm w-max-content w-max max-w-128"
          >
            {{ label }}
          </div>
        </transition>
      </template>
    </info-bulle>
    <div class="relative h-full">
      <div
        class="border border-opacity-50 rounded-md block w-full appearance-none sm:leading-5 truncate border-indigo-600 bg-gray-200 cursor-not-allowed text-sm px-3 py-2 xxl:px-4 xxl:py-3 2xl:px-5 2xl:py-4"
        @mouseover="showToolTip = true"
        @mouseleave="showToolTip = false"
        :class="{ 'h-full': growsVertically }"
      >
        <span
          v-for="(val, i) in valueComp"
          :key="`${val.newValue}${i}`"
          :class="{
            'text-teal-600': val.action === 'added',
            'text-indigo-600': val.action === 'updated',
            'text-pink-600': val.action === 'deleted',
            'text-gray-600': val.action === 'none',
          }"
        >
          {{ display(val) }}<span v-if="i + 2 <= valueComp.length">,</span>
        </span>
        <!-- Display value when hover -->
        <transition
          enter-active-class="duration-300 delay-300"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="duration-300"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="showToolTip && valueAsStr.length > 0"
            class="absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-12 z-30 p-3 text-sm w-max-content w-max max-w-128"
          >
            {{ valueAsStr }}
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import InfoBulle from '../../components/InfoBulle.vue';

export default {
  components: { InfoBulle },
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },
    value: {
      type: [Array, Object],
      required: false,
      default: () =>
        new Object({ newValue: null, previous: null, action: 'none' }),
    },
    growsVertically: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      tooltipLabel: false,
      showToolTip: false,
    };
  },

  methods: {
    display({ newValue, action, previous }) {
      const isDateString = (value) => {
        return (
          value &&
          typeof value === 'string' &&
          // matches datestrings : YYYY-MM-DDThh:mm:ss:msZ
          value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/)
        );
      };

      if (isDateString(newValue)) {
        newValue = new Date(newValue).toLocaleDateString();
      }

      if (isDateString(previous)) {
        previous = new Date(previous).toLocaleDateString();
      }

      if (typeof newValue === 'boolean') {
        newValue = newValue ? 'Oui' : 'Non';
      }

      if (typeof previous === 'boolean') {
        previous = previous ? 'Oui' : 'Non';
      }

      switch (action) {
      case 'added':
        return `+ ${newValue}`;
      case 'updated':
        return `${previous} -> ${newValue}`;
      case 'deleted':
        return `-${previous}`;
      default:
        return newValue?.length > 0 ? newValue : 'N/A';

      }
    },
  },

  computed: {
    valueAsStr() {
      let result = '';

      this.valueComp.forEach(({ newValue, action, previous }, idx) => {
        if (action === 'added') {
          result += `+ ${newValue}`;
        } else if (action === 'deleted') {
          result += `- ${previous}`;
        } else if (action === 'updated') {
          result += `${previous} -> ${newValue}`;
        } else {
          result += newValue ?? '';
        }
        if (idx + 2 <= this.value.length) {
          result += ', ';
        }
      });

      return result;
    },

    valueComp() {
      if (Array.isArray(this.value.value ?? null)) {
        return this.value.value;
      }

      return [this.value];
    },
  },
};
</script>